import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="w-full bg-accent-50 border-t border-background-200/60">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-10 md:py-12">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="text-center md:text-left">
            <Link to="/" className="text-lg font-heading font-semibold text-foreground-900 hover:text-primary-500 transition-colors duration-200 cursor-pointer">
              {t('site.title')}
            </Link>
            <p className="text-xs text-foreground-500 mt-2 max-w-md">
              {t('footer.disclaimer')}
            </p>
          </div>

          <div className="flex flex-col items-center md:items-end gap-3">
            <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2">
              <Link to="/" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors duration-200 cursor-pointer whitespace-nowrap">
                {t('footer.homeLink')}
              </Link>
              <Link to="/#articles-section" className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors duration-200 cursor-pointer whitespace-nowrap">
                {t('footer.shoppingGuideLink')}
              </Link>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                Kaspreadsheet
              </a>
            </div>
            <p className="text-xs text-foreground-400">
              {t('footer.copyright')}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}